import {
  MixpanelEvents,
  type ModuleDialogProperties,
  type SimulationCompleteProperties,
  type SimulationStartProperties,
} from "@/types/mixpanel";
import mixpanel from "mixpanel-browser";

export const trackSimulationStart = (
  properties?: SimulationStartProperties,
) => {
  mixpanel.time_event(MixpanelEvents.SIMULATION_COMPLETED);

  mixpanel.track(MixpanelEvents.SIMULATION_STARTED, {
    ...properties,
    timestamp: new Date().toISOString(),
  });
};

export const trackSimulationComplete = (
  properties?: SimulationCompleteProperties,
) => {
  mixpanel.track(MixpanelEvents.SIMULATION_COMPLETED, {
    ...properties,
    timestamp: new Date().toISOString(),
  });
};

export const trackModuleDialogOpened = (
  properties?: ModuleDialogProperties,
) => {
  // Use time_event to start tracking duration
  mixpanel.time_event(MixpanelEvents.MODULE_DIALOG_CLOSED);

  mixpanel.track(MixpanelEvents.MODULE_DIALOG_OPENED, {
    ...properties,
    timestamp: new Date().toISOString(),
  });
};

export const trackModuleDialogClosed = (
  properties?: ModuleDialogProperties,
) => {
  // Mixpanel automatically calculates duration since last time_event call
  mixpanel.track(MixpanelEvents.MODULE_DIALOG_CLOSED, {
    ...properties,
    timestamp: new Date().toISOString(),
  });
};

export const identifyUser = (
  userId: string,
  properties?: {
    $name?: string;
    $email?: string;
    title?: string;
    [key: string]: any;
  },
) => {
  // Set the Distinct ID
  mixpanel.identify(userId);

  // Set user profile properties
  if (properties) {
    mixpanel.people.set(properties);
  }

  // Set super properties (will be included in every event)
  if (properties) {
    mixpanel.register({
      userId,
      userName: properties.$name,
      userEmail: properties.$email,
    });
  }
};

export const resetMixpanel = () => {
  mixpanel.reset();
};
